// DESCRIPTION: Entry point for the Nemtly Events query loop variation.
// Registers the variation and custom inspector controls.

import './query-variation';
import './events-query-controls';
